import type { TFunction } from 'i18next';
import type { AnalysisUnit } from '../../../../services/analysis/analysisService';

/**
 * Translated quantity labels for the Analysis pages. `fmtBase` (utils/reports/shared.ts)
 * hardcodes the English kg / L / pcs labels, so these pages use their own translated
 * twin. The rounding matches fmtBase.
 */

/** Translated short unit label for a money-savers unit (kg | l | p). */
export const unitLabel = (t: TFunction, unit: AnalysisUnit): string => t(`analysis.unit.${unit}`);

/** Money-savers quantity in shop units, e.g. "12.5 kg" / "40 st.". */
export const fmtShopQty = (t: TFunction, qty: number | null, unit: AnalysisUnit | null): string =>
  qty === null || unit === null ? '—' : `${Math.round(qty * 100) / 100} ${unitLabel(t, unit)}`;

/** Utilization base-unit quantity (g | ml | p) shown in shop units, same rounding as fmtBase. */
export const fmtBaseQty = (t: TFunction, value: number, stdUnit: string): string => {
  if (stdUnit === 'g') return `${(value / 1000).toFixed(2)} ${unitLabel(t, 'kg')}`;
  if (stdUnit === 'ml') return `${(value / 1000).toFixed(2)} ${unitLabel(t, 'l')}`;
  if (stdUnit === 'p') return `${Math.round(value)} ${unitLabel(t, 'p')}`;
  return String(Math.round(value * 1000) / 1000);
};
